import { useContextTS } from "@inrange/utils";
import { useKindeAuth } from "@kinde-oss/kinde-auth-react";
import { useQuery } from "@tanstack/react-query";
import { getUserOrgId } from "../getUserOrgId";
import getSiteFileDownloadUrl from "../http/getSiteFileDownloadUrl";
import { SiteFile } from "../models/site";
import { ReloginContext } from "../ReloginContext";
import { getAuthTokenBlocking } from "./utils";

interface SiteFileDownloadParams {
  siteId: string;
  file: SiteFile;
  isAttachment?: boolean;
  enabled?: boolean;
  userOrgId?: string;
}

const useSiteFileDownload = ({
  siteId,
  file,
  isAttachment,
  enabled,
  userOrgId: userOrgIdParam,
}: SiteFileDownloadParams) => {
  const { getToken, getClaim } = useKindeAuth();
  const { relogin } = useContextTS(ReloginContext);

  const fetchSiteFileURL = useQuery(
    ["siteFile", siteId, file],
    async () => {
      return getSiteFileDownloadUrl(
        await getAuthTokenBlocking(getToken, relogin),
        siteId,
        file.fileType,
        file.fileName,
        file.fileGuid,
        isAttachment,
        await getUserOrgId(getClaim, userOrgIdParam)
      );
    },
    {
      enabled: enabled ?? true,
    }
  );

  return {
    fetchSiteFileURL,
  };
};

export default useSiteFileDownload;
